export const styles = {
  // Global styles to override some Chakra defaults
  global: {
    body: {
      bg: 'background',
      color: 'text.body',
      position: 'static',
    },
  },
}
